import type { ReactNode } from 'react';
import { roleAtLeast, type ViewerTier } from './roles';

/** Context handed to a section's render function so its controls can self-gate
 *  and close the drawer (e.g. after a destructive action). */
export interface AdminSectionContext {
  viewer: ViewerTier;
  close: () => void;
}

export interface AdminSection {
  /** Stable id — React key, aria target, and deep-link anchor (`?settings=<key>`). */
  key: string;
  /** Heading shown in the drawer. */
  title: string;
  /** Optional leading glyph (e.g. <KeyIcon /> for Security). */
  icon?: ReactNode;
  /** Minimum tier to SEE the whole section. Omit ⇒ visible to every viewer. */
  minRole?: ViewerTier;
  /** Section body — a node, or a function of the viewer context so the body can
   *  gate its own controls / close the drawer without threading props. */
  body: ReactNode | ((ctx: AdminSectionContext) => ReactNode);
}

/** Pure section filter (extracted so it is unit-testable without a DOM). */
export function filterSections(sections: AdminSection[], viewer: ViewerTier): AdminSection[] {
  return sections.filter((s) => !s.minRole || roleAtLeast(viewer, s.minRole));
}
